export default function MapPinIcon({ width = "30px", fill = "#000" }: { width?: string, fill?: string }) {
    return (
        <svg width={width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path d="M12 22C12 22 20 14.5 20 9C20 4.58172 16.4183 1 12 1C7.58172 1 4 4.58172 4 9C4 14.5 12 22 12 22Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <circle cx="12" cy="9" r="2.5" stroke={fill} strokeWidth="1.5"></circle>
            </g>
        </svg>
    )
}
